import { PaymentTaskExpenseAccountItem } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 2410. 週次分析スナップショット作成
 * [POST] /workspaces/:identifier/weekly_summaries
 */
type Props = {
  identifier: string;
};
const createWeeklySummary = (props: Props): Promise<any> => {
  return axios.post(`/api/workspaces/${props.identifier}/weekly_summaries`, props);
};

export const useCreateWeeklySummary = () => {
  return useMutation({
    mutationFn: createWeeklySummary,
  });
};
